import Application from './application/Application'
Application.run()
